
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Msg from 'vux/src/components/msg/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'

export default {
name: 'ApplyTryPage',
components: {
XInput,
XButton,
Group,
Cell,
Msg,
Checklist
},
data () {
return {
formParam: {
user_name: '',
company_name: '',
company_address: '',
mobile: '',
wechat: '',
work: ''
},
submitSuccess: false,
buttons: [{
type: 'default',
text: '关闭',
onClick: this.closePage.bind(this)
}]
}
},
methods: {
closePage: function () {
let that = this
that.submitSuccess = false
},
submitSignUp: function () {
let that = this

if (that.$Utils.IsEmpty(that.formParam.user_name)) {
that.$Msgbox.alert('姓名必填')
return
}

/* if (that.$Utils.IsEmpty(that.formParam.company_name)) {
that.$Msgbox.alert('公司必填')
return
} */

/* if (that.$Utils.IsEmpty(that.formParam.company_address)) {
that.$Msgbox.alert('地址必填')
return
} */

if (that.$Utils.IsEmpty(that.formParam.mobile)) {
that.$Msgbox.alert('手机号必填')
return
}

if (that.$Utils.IsEmpty(that.formParam.wechat)) {
that.$Msgbox.alert('微信必填')
return
}

/* if (that.$Utils.IsEmpty(that.formParam.work)) {
that.$Msgbox.alert('从事工作必填')
return
} */

let url = '/wxapi/user/submitSignUpCityPartner'
this.$axios.post(url, {}, {params: that.formParam}).then(function (res) {
if (res.meta.success) {
that.submitSuccess = true
} else {
console.error(res.meta.message)
that.$Msgbox.alert(res.meta.message, '异常提示')
}
}).catch(function (error) {
console.info(error)
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/user/SignUpCityPartner.vue